"use client";

import { AnimatePresence, motion } from "framer-motion";
import { Icon } from "@/components/ui/icon";
import { contentVariants, STEP_2_EMPLOYER_META, STEP_META } from "./constants";

interface WizardHeaderProps {
  currentStep: number;
  dir: number;
  creatingWorkspace: boolean;
  onEmployerSubStep?: boolean;
}

export function WizardHeader({
  currentStep,
  dir,
  creatingWorkspace,
  onEmployerSubStep,
}: WizardHeaderProps) {
  const meta = onEmployerSubStep
    ? STEP_2_EMPLOYER_META
    : creatingWorkspace
      ? { label: "Create workspace", title: "Create your workspace" }
      : STEP_META[currentStep];

  const motionKey = onEmployerSubStep
    ? `header-${currentStep}-employer`
    : `header-${currentStep}`;

  return (
    <AnimatePresence mode="wait" custom={dir}>
      <motion.div
        key={motionKey}
        custom={dir}
        variants={contentVariants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{ type: "spring", damping: 30, stiffness: 350, mass: 0.8 }}
        className="flex flex-col gap-1 shrink-0"
      >
        <div className="flex items-center gap-0.5">
          <span className="text-[13px] font-medium text-contrast/50 tracking-[-0.13px] leading-5">
            Step {currentStep}
          </span>
          <Icon
            name="IconChevronRightSmall"
            size={14}
            className="text-heading opacity-30"
          />
          <span className="text-[13px] font-medium text-heading tracking-[-0.13px] leading-5">
            {meta.label}
          </span>
        </div>
        <h2 className="text-xl sm:text-2xl font-semibold text-heading sm:leading-8">
          {meta.title}
        </h2>
      </motion.div>
    </AnimatePresence>
  );
}
